import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-base',
  templateUrl: './dashboard-base.component.html',
  styleUrls: ['./dashboard-base.component.scss']
})
export class DashboardBaseComponent implements OnInit {

  constructor() { }

  currentView:boolean = true; // true means view one false means view two
  
  value:string="";

  ngOnInit(): void {
  }


  selectedCardReceiver(event:any){
      this.value = event;
      this.currentView = false;
  }

}
